/* eslint-disable no-octal */
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import moment from "moment";
import { verificarDiaMes } from "utils/verificarDiaMes";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Grid,
  Button,
  Select,
  Box,
  Text,
  CircularProgress,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Icon,
  IconButton,
  Divider,
  AlertIcon,
  Alert,
} from "@chakra-ui/react";
import AddSection from "Components/AddSection";
import Swal from "sweetalert2";
import api from "services/api";
import MaterialTable from "material-table";
import { tableIcons } from "utils/tableIcons";
import { FormataStringData } from "utils/formatData";
import { MdModeEdit, MdFolderOpen } from "react-icons/md";
import { addZeroes } from "utils/addZeroes";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";

interface Entidade {
  id: number;
  nm_entidade: string;
  tipos_entidade: {
    tp_entidade: string;
  };
}

interface Operadora {
  id: number;
  nm_operadora: string;
}

interface TipoContrato {
  id: number;
  tp_contrato: string;
}

interface Contract {
  id: number;
  desc_contrato: string;
  dt_ini_vigencia: string;
  dt_fim_vigencia: string;
  tipos_contrato: any;
  operadora: any;
  entidade: any;
  entidade_vinculada: any;
  fl_ativo: any;
  fl_copart: any;
  dia_notificacao: any;
  dia_venc_copart: any;
  status: any;
  fl_resp_pelo_pagamento: any;
  dia_venc_extrato_boleto_nota: any;
  mes_ini_vigenc_ext_bol_not: any;
  ano_ini_vigenc_ext_bol_not: any;
  fl_extrato_boleto_nota: any;
  dia_limite_ext_bol_not: any;
  fl_libera_valid_extbolnot_mes_anterior: any;
  tipo_movimentacao: any;
  ano_inicio_repasse: any;
  mes_inicio_repasse: any;
  dia_repasse: any;
  periodo_vencimento: any;
  fl_sinistralidade: any;
  dia_recebimento_arq_sinist: any;
}

interface EndContract {
  dt_fim_vigencia: string;
}

const dias = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];

const meses = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

const defaultValues = {
  dt_ini_vigencia: "",
  desc_contrato: "",
  status: "",
  tipos_contrato: "",
  operadora: "",
  entidade: "",
  entidade_vinculada: "",
  fl_copart: "nao",
  dia_notificacao: "01",
  dia_venc_copart: "01",
  fl_resp_pelo_pagamento: "F",
  dia_venc_extrato_boleto_nota: "01",
  mes_ini_vigenc_ext_bol_not: moment().month() + 1,
  ano_ini_vigenc_ext_bol_not: moment().year(),
  fl_extrato_boleto_nota: "",
  dia_limite_ext_bol_not: "01",
  fl_libera_valid_extbolnot_mes_anterior: "nao",
  tipo_movimentacao: "",
  ano_inicio_repasse: moment().year(),
  mes_inicio_repasse: moment().month() + 1,
  dia_repasse: "01",
  periodo_vencimento: "1",
};

const defaultValues2 = {
  dt_fim_vigencia: "",
};

const schema = Yup.object().shape({
  dt_ini_vigencia: Yup.string().required(
    "Preencha a data de início da Vigência",
  ),
  desc_contrato: Yup.string().required("Preencha o nome do Contrato"),
  tipos_contrato: Yup.string().required("Preencha o tipo do contrato"),
  operadora: Yup.string().required("Preencha a operadora"),
  entidade: Yup.string().required("Preencha a pessoa jurídica"),
});

const schema2 = Yup.object().shape({
  dt_fim_vigencia: Yup.string().required("Preencha a data de fim da Vigência"),
});

const Contratos = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [entidades, setEntidades] = useState<Entidade[]>([]);
  const [operadoras, setOperadoras] = useState<Operadora[]>([]);
  const [tipoContratos, setTipoContratos] = useState<TipoContrato[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [inputDtIniVigencia, setInputDtIniVigencia] = useState<any>();
  const [inputDescContrato, setInputDescContrato] = useState<any>();
  const [inputTipos_Contrato, setInputTipos_Contrato] = useState<any>();
  const [inputOperadora, setInputOperadora] = useState<any>();
  const [inputEntidade, setInputEntidade] = useState<any>();
  const [inputEntidadeVinculada, setInputEntidadeVinculada] = useState<any>();
  const [inputFl_copart, setInputFl_copart] = useState<any>();
  const [inputFl_sinistralidade, setInputFl_sinistralidade] = useState<any>();
  const [inputDia_notificacao, setInputDia_notificacao] = useState<any>();
  const [inputDia_sinistralidade, setInputDia_sinistralidade] = useState<any>();
  const [inputDia_venc_copart, setInputDia_venc_copart] = useState<any>();
  const [vinculo, setVinculo] = useState<any>();
  const [respPeloPagamento, setRespPeloPagamento] = useState<any>();
  const [tipoMovimentacao, setTipoMovimentacao] = useState<any>(null);
  const [coparticipacao, setCoparticipacao] = useState<any>();
  const [sinistralidade, setSinistralidade] = useState<any>();
  const [contracts, setContracts] = useState<Contract[]>([]);
  const [currentEditing, setCurrentEditing] = useState<null | number>(null);
  const [currentClosing, setCurrentClosing] = useState<null | number>(null);
  const [currentIniVigencia, setCurrentIniVigencia] = useState<any>(null);
  const [dateClosingError, setDateClosingError] = useState<boolean>(false);
  const [editLoading, setEditLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [fl_copart, setFl_copart] = useState(false);
  const [fl_sinistralidade, setFl_sinistralidade] = useState(false);
  const [fl_copartValue, setFl_copartValue] = useState<any>();
  const [fl_sinistralidadeValue, setFl_sinistralidadeValue] = useState<any>();
  const [entidadeValue, setEntidadeValue] = useState<any>();
  const [pessoaJuridicaName, setPessoaJuridicaName] = useState<any>();
  const [pessoaJuridicaType, setPessoaJuridicaType] = useState<any>();
  const [entidadeVinculadaName, setEntidadeVinculadaName] = useState<any>();
  const [limiteData, setLimiteData] = useState<any>();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm<Contract>({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    formState: { errors: errors2, isSubmitting: isSubmitting2 },
  } = useForm<EndContract>({
    mode: "onBlur",
    resolver: yupResolver(schema2),
  });

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => {
    async function getOperadoras() {
      try {
        const response = await api.get("/operadoras");
        setOperadoras(response.data);
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar as operadoras",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }

    async function getEntidades() {
      try {
        const response = await api.get("/entidades");
        setEntidades(response.data);
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar as pessoas jurídicas",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }
    async function getTipoContratos() {
      try {
        const response = await api.get("/tipos-contratoes");
        setTipoContratos(response.data);
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar os tipos de contratos",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }

    async function getContracts() {
      try {
        const response = await api.get("/contratoes?_sort=updated_at:DESC");
        setContracts(response.data);
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar os contratos",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
      setPageLoading(false);
    }

    getTipoContratos();
    getOperadoras();
    getEntidades();
    getContracts();
  }, []);

  async function handleEditContato() {
    Swal.fire({
      title: "Tem certeza que deseja editar esse contrato?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setEditLoading(true);
        try {
          const response = await api.put(`/contratoes/${currentEditing}`, {
            dt_ini_vigencia: inputDtIniVigencia,
            desc_contrato: inputDescContrato,
            tipos_contrato: inputTipos_Contrato,
            operadora: inputOperadora,
            entidade: inputEntidade,
            entidade_vinculada: inputEntidadeVinculada,
            //fl_copart: inputFl_copart,
            //dia_notificacao: inputDia_notificacao,
            //dia_venc_copart: inputDia_venc_copart,
          });

          const updatedContratos = contracts.map((contrato) => {
            if (contrato.id === currentEditing) {
              return response.data;
            }
            return contrato;
          });

          setContracts(updatedContratos);
          setActiveStep(0);
          setInputDtIniVigencia("");
          setInputDescContrato("");
          setInputTipos_Contrato("");
          setInputOperadora("");
          setInputEntidade("");
          setInputEntidadeVinculada("");
          setInputFl_copart("");
          setInputFl_sinistralidade("");
          setInputDia_notificacao("");
          setInputDia_sinistralidade("");
          setInputDia_venc_copart("");
          setCoparticipacao("");
          setSinistralidade("");
          setVinculo(null);
          setCurrentEditing(null);
          setEditLoading(false);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Contrato editado com sucesso",
            showConfirmButton: false,
            timer: 3000,
          });
        } catch (err) {
          console.log(err);
          setEditLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro ao editar",
            showConfirmButton: true,
            confirmButtonText: `Ok`,
          });
        }
      }
    });
  }

  const onSubmit = async (values: Contract) => {
    const type =
      entidades.find(
        (op) =>
          op.id ===
          parseInt(
            values?.entidade_vinculada < 0
              ? values?.entidade_vinculada
              : values.entidade,
          ),
      )?.tipos_entidade?.tp_entidade === "Empresa";

    const data = {
      dt_ini_vigencia: values.dt_ini_vigencia,
      desc_contrato: values.desc_contrato,
      fl_ativo: true,
      // status: values.status,
      tipos_contrato: values.tipos_contrato,
      operadora: values.operadora,
      entidade: values.entidade,
      entidade_vinculada:
        values?.entidade_vinculada?.length > 0
          ? values.entidade_vinculada
          : null,
      fl_copart:
        values.fl_copart === "nao" ? false : values.fl_copart === "sim" && true,
      fl_sinistralidade:
        values.fl_sinistralidade === "nao"
          ? false
          : values.fl_sinistralidade === "sim" && true,
      dia_notificacao: fl_copart ? values.dia_notificacao : null,
      dia_venc_copart: fl_copart ? values.dia_venc_copart : null,
      dia_recebimento_arq_sinist: fl_sinistralidade
        ? values.dia_recebimento_arq_sinist
        : null,
      fl_resp_pelo_pagamento:
        type &&
        (values.fl_resp_pelo_pagamento === "P" ||
          values.fl_resp_pelo_pagamento === "E")
          ? values.fl_resp_pelo_pagamento
          : null,
      dia_venc_extrato_boleto_nota:
        (tipoMovimentacao === "cobrança" ||
          values.tipo_movimentacao === "cobrança") &&
        tipoMovimentacao !== null
          ? values.dia_venc_extrato_boleto_nota
          : null,
      dia_limite_ext_bol_not:
        (tipoMovimentacao === "cobrança" ||
          values.tipo_movimentacao === "cobrança") &&
        tipoMovimentacao !== null
          ? values.dia_limite_ext_bol_not
          : null,
      mes_ini_vigenc_ext_bol_not:
        (tipoMovimentacao === "cobrança" ||
          values.tipo_movimentacao === "cobrança") &&
        tipoMovimentacao !== null
          ? values.mes_ini_vigenc_ext_bol_not
          : null,
      ano_ini_vigenc_ext_bol_not:
        (tipoMovimentacao === "cobrança" ||
          values.tipo_movimentacao === "cobrança") &&
        tipoMovimentacao !== null
          ? values.ano_ini_vigenc_ext_bol_not
          : null,
      fl_extrato_boleto_nota:
        (type &&
          (values.fl_resp_pelo_pagamento === "P" ||
            values.fl_resp_pelo_pagamento === "E")) ||
        (!type &&
          (tipoMovimentacao === "cobrança" ||
            values.tipo_movimentacao === "cobrança") &&
          tipoMovimentacao !== null)
          ? true
          : false,
      fl_libera_valid_extbolnot_mes_anterior:
        (type &&
          (values.fl_resp_pelo_pagamento === "P" ||
            values.fl_resp_pelo_pagamento === "E")) ||
        (!type &&
          (tipoMovimentacao === "cobrança" ||
            values.tipo_movimentacao === "cobrança") &&
          tipoMovimentacao !== null)
          ? values.fl_libera_valid_extbolnot_mes_anterior === "não"
            ? false
            : values.fl_libera_valid_extbolnot_mes_anterior === "sim" && true
          : false,
      fl_repasse_taxa:
        tipoMovimentacao === "repasse_taxas" &&
        values.tipo_movimentacao === "repasse_taxas",
      dia_repasse:
        tipoMovimentacao === "repasse_taxas" &&
        values.tipo_movimentacao === "repasse_taxas"
          ? values.dia_repasse
          : null,
      mes_inicio_repasse:
        tipoMovimentacao === "repasse_taxas" &&
        values.tipo_movimentacao === "repasse_taxas"
          ? values.mes_inicio_repasse
          : null,
      ano_inicio_repasse:
        tipoMovimentacao === "repasse_taxas" &&
        values.tipo_movimentacao === "repasse_taxas"
          ? values.ano_inicio_repasse
          : null,
      periodo_vencimento:
        tipoMovimentacao === "repasse_taxas" &&
        values.tipo_movimentacao === "repasse_taxas"
          ? parseInt(values.periodo_vencimento)
          : null,
    };

    await api
      .post("/contratoes", data)
      .then(async (res) => {
        // DOCUMENTO DE COBRANÇA
        if (res.data.fl_extrato_boleto_nota) {
          const contratoVigente = res.data;

          const fl_libera =
            contratoVigente?.fl_libera_valid_extbolnot_mes_anterior;

          const dataVigente = moment(
            `${contratoVigente?.ano_ini_vigenc_ext_bol_not}-${contratoVigente?.mes_ini_vigenc_ext_bol_not}`,
          );

          const currentDate = fl_libera
            ? moment().add(1, "month").format()
            : moment().format();

          if (currentDate >= dataVigente.format()) {
            const documentData = {
              ano_competencia:
                fl_libera && currentDate >= dataVigente.format()
                  ? moment().add(1, "month").year()
                  : moment().year(),
              mes_competencia:
                fl_libera && currentDate >= dataVigente.format()
                  ? moment().add(1, "month").month() + 1
                  : moment().month() + 1,
              tipo_documento: 1,
              operadora: contratoVigente?.operadora,
              entidade:
                contratoVigente?.fl_resp_pelo_pagamento === "E"
                  ? contratoVigente?.entidade_vinculada
                  : contratoVigente?.entidade,
              contrato: contratoVigente?.id,
              dt_vencimento: moment([
                fl_libera && currentDate >= dataVigente.format()
                  ? moment().add(1, "month").year()
                  : moment().year(),
                fl_libera && currentDate >= dataVigente.format()
                  ? moment().add(1, "month").month()
                  : moment().month(),
                verificarDiaMes(
                  parseInt(contratoVigente?.dia_venc_extrato_boleto_nota),
                  fl_libera && currentDate >= dataVigente.format()
                    ? moment().add(1, "month").month()
                    : moment().month(),
                ),
              ])
                .add(1, "M")
                .format("YYYY-MM-DD"),
              status_documento: 1,
              valor: null,
              fl_envia_pos_limite: false,
              fl_validando_ext_bol_not: false,
            };

            await api
              .post("/documentos", documentData)
              .then(async (res) => {})
              .catch((error) => {
                console.log("erro: ", error);
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro 02 ao criar documento! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
          }

          if (
            fl_libera &&
            dataVigente.format("MM/YYYY") === moment().format("MM/YYYY")
          ) {
            const documentData = {
              ano_competencia: moment().year(),
              mes_competencia: moment().month() + 1,
              tipo_documento: 1,
              operadora: contratoVigente?.operadora,
              entidade:
                contratoVigente?.fl_resp_pelo_pagamento === "P"
                  ? contratoVigente?.entidade
                  : contratoVigente?.fl_resp_pelo_pagamento === "E" &&
                    contratoVigente?.entidade_vinculada,
              contrato: contratoVigente?.id,
              dt_vencimento: moment([
                moment().year(),
                moment().month(),
                verificarDiaMes(
                  parseInt(contratoVigente?.dia_venc_extrato_boleto_nota),
                  moment().month(),
                ),
              ])
                .add(1, "M")
                .format("YYYY-MM-DD"),
              status_documento: 1,
              valor: null,
              fl_envia_pos_limite: false,
              fl_validando_ext_bol_not: false,
            };

            await api
              .post("/documentos", documentData)
              .then(async (res) => {})
              .catch((error) => {
                console.log("erro: ", error);
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro 01 ao criar documento! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
          }
        }

        // DOCUMENTO DE SINISTRALIDADE
        if (res.data.fl_sinistralidade) {
          const contratoVigente = res.data;

          const dataVigente = moment(
            `${contratoVigente?.ano_ini_vigenc_ext_bol_not}-${contratoVigente?.mes_ini_vigenc_ext_bol_not}`,
          );

          const currentDate = moment().format();

          if (currentDate >= dataVigente.format()) {
            const documentData = {
              ano_competencia: moment().year(),
              mes_competencia: moment().month() + 1,
              tipo_documento: 10,
              operadora: contratoVigente?.operadora,
              entidade: contratoVigente?.entidade,
              contrato: contratoVigente?.id,
              dt_vencimento: moment([
                moment().year(),
                moment().month(),
                verificarDiaMes(
                  parseInt(contratoVigente?.dia_recebimento_arq_sinist),
                  moment().month(),
                ),
              ])
                .add(1, "M")
                .format("YYYY-MM-DD"),
              status_documento: 1,
              valor: null,
              fl_envia_pos_limite: false,
            };

            await api
              .post("/documentos", documentData)
              .then(async (res) => {})
              .catch((error) => {
                console.log("erro: ", error);
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro ao criar documento! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
          }
        }

        // DOCUMENTO DE COPARTICIPAÇÃO
        if (res.data.fl_copart) {
          const contratoVigente = res.data;

          const dataVigente = moment(contratoVigente?.Dt_ini_vigencia).format();

          const currentDate = moment().format();

          if (currentDate >= dataVigente) {
            const documentData = {
              ano_competencia: moment().year(),
              mes_competencia: moment().month() + 1,
              tipo_documento: 7,
              operadora: contratoVigente?.operadora,
              entidade: contratoVigente?.entidade,
              contrato: contratoVigente?.id,
              dt_vencimento: moment([
                moment().year(),
                moment().month(),
                verificarDiaMes(
                  parseInt(contratoVigente?.dia_venc_copart),
                  moment().month(),
                ),
              ])
                .add(1, "M")
                .format("YYYY-MM-DD"),
              valor: null,
              id_arquivo: null,
              nome_arquivo: null,
              hash_arquivo: null,
              status_documento: 1,
              fl_envia_pos_limite: false,
            };

            await api
              .post("/documentos", documentData)
              .then(async (res) => {})
              .catch((error) => {
                console.log("erro: ", error);
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro ao criar documento! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
          }
        }

        // DOCUMENTO DE REPASSE DE TAXAS
        if (res.data.fl_repasse_taxa) {
          const contratoVigente = res.data;

          const dataVigente = moment(
            `${contratoVigente?.ano_inicio_repasse}-${contratoVigente?.mes_inicio_repasse}`,
          );

          const currentDate = moment().format();

          if (currentDate >= dataVigente.format()) {
            const documentData = {
              ano_competencia: moment().year(),
              mes_competencia: moment().month() + 1,
              tipo_documento: 2,
              operadora: contratoVigente?.operadora,
              entidade: contratoVigente?.entidade,
              contrato: contratoVigente?.id,
              dt_vencimento: moment([
                contratoVigente.periodo_vencimento.id === 3
                  ? moment().add(2, "month").year()
                  : contratoVigente.periodo_vencimento.id === 2
                  ? moment().add(1, "month").year()
                  : moment().year(),
                contratoVigente.periodo_vencimento.id === 3
                  ? moment().add(2, "month").month()
                  : contratoVigente.periodo_vencimento.id === 2
                  ? moment().add(1, "month").month()
                  : moment().month(),
                verificarDiaMes(
                  parseInt(contratoVigente?.dia_repasse),
                  contratoVigente.periodo_vencimento.id === 3
                    ? moment().add(2, "month").month()
                    : contratoVigente.periodo_vencimento.id === 2
                    ? moment().add(1, "month").month()
                    : moment().month(),
                ),
              ]).format("YYYY-MM-DD"),
              status_documento: 1,
              valor: null,
              fl_envia_pos_limite: false,
            };

            await api
              .post("/documentos", documentData)
              .then(async (res) => {})
              .catch((error) => {
                console.log("erro: ", error);
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro ao criar documento! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
          }
        }

        reset(defaultValues);
        setFl_copart(false);
        setFl_sinistralidade(false);
        setFl_copartValue(null);
        setFl_sinistralidadeValue(null);
        setEntidadeValue(null);
        setRespPeloPagamento(null);
        setTipoMovimentacao(null);
        setVinculo(null);
        setActiveStep(0);
        setPessoaJuridicaName(null);
        setPessoaJuridicaType(null);
        setEntidadeVinculadaName(null);
        setContracts([res.data, ...contracts]);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Contrato cadastrado com sucesso",
          showConfirmButton: false,
          timer: 3000,
        });
      })
      .catch((error) => {
        console.log("erro: ", error);
        Swal.fire({
          icon: "warning",
          title:
            "Algo deu errado! Entre em contato com o administrador do sistema",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      });
  };

  const onSubmit2 = async (values: EndContract) => {
    Swal.fire({
      title: "Tem certeza que deseja encerrar esse contrato?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = {
          dt_fim_vigencia: values.dt_fim_vigencia,
          fl_ativo: false,
        };

        try {
          const response = await api.put(`/contratoes/${currentClosing}`, data);

          const updatedContratos = contracts.map((contrato) => {
            if (contrato.id === currentClosing) {
              return response.data;
            }
            return contrato;
          });
          reset2();
          setContracts(updatedContratos);
          setCurrentClosing(null);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Contrato encerrado com sucesso",
            showConfirmButton: false,
            timer: 3000,
          });
        } catch (err) {
          console.log(err);
          Swal.fire({
            icon: "error",
            title:
              "Erro ao encerraro o contrato! Entre em contato com o administrado do sistema.",
            showConfirmButton: true,
            confirmButtonText: `Ok`,
          });
        }
      }
    });
  };

  if (pageLoading) {
    return (
      <Box
        as="section"
        display="flex"
        w="100%"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress isIndeterminate color="blue.200" />
      </Box>
    );
  }

  return (
    <>
      <Box
        as="section"
        display="flex"
        flexDir="column"
        w="100%"
        maxHeight="calc(100vh - 72px)"
        overflow="auto"
        pb="4"
      >
        <AddSection titleButton="Cadastrar Contrato" scrollBehavior="inside">
          <form
            onSubmit={handleSubmit(onSubmit)}
            onReset={(event) => {
              event.preventDefault();
              reset(defaultValues);
            }}
          >
            <Stepper activeStep={activeStep} orientation="vertical">
              <Step key="1">
                <StepLabel>
                  <Text fontSize="16px">Dados do contrato</Text>
                </StepLabel>
                <StepContent>
                  <Grid gap={6}>
                    <FormControl
                      isInvalid={!!errors?.dt_ini_vigencia?.message}
                      errortext={errors?.dt_ini_vigencia?.message}
                      isRequired
                    >
                      <FormLabel htmlFor="dt_ini_vigencia">
                        Data de início da Vigência
                      </FormLabel>
                      <Input
                        id="dt_ini_vigencia"
                        type="date"
                        {...register("dt_ini_vigencia")}
                      />
                      <FormErrorMessage>
                        {errors?.dt_ini_vigencia?.message}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      isInvalid={!!errors?.desc_contrato?.message}
                      errortext={errors?.desc_contrato?.message}
                      isRequired
                    >
                      <FormLabel htmlFor="desc_contrato">
                        Nome do contrato
                      </FormLabel>
                      <Input
                        id="desc_contrato"
                        type="text"
                        {...register("desc_contrato")}
                      />
                      <FormErrorMessage>
                        {errors?.desc_contrato?.message}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      isInvalid={!!errors?.tipos_contrato?.message}
                      errortext={errors?.tipos_contrato?.message}
                      isRequired
                    >
                      <FormLabel htmlFor="tipos_contrato">
                        Tipo do contrato
                      </FormLabel>
                      <Select
                        placeholder="Selecione o tipo"
                        id="tipos_contrato"
                        type="text"
                        {...register("tipos_contrato")}
                      >
                        {tipoContratos &&
                          tipoContratos.map((tipo) => (
                            <option key={tipo.id} value={tipo.id}>
                              {tipo.tp_contrato}
                            </option>
                          ))}
                      </Select>
                      <FormErrorMessage>
                        {errors?.tipos_contrato?.message}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      isInvalid={!!errors?.operadora?.message}
                      errortext={errors?.operadora?.message}
                      isRequired
                    >
                      <FormLabel htmlFor="operadora">Operadora</FormLabel>
                      <Select
                        placeholder="Selecione uma operadora"
                        id="operadora"
                        type="text"
                        {...register("operadora")}
                      >
                        {operadoras &&
                          operadoras.map((operadora) => (
                            <option key={operadora.id} value={operadora.id}>
                              {operadora.nm_operadora}
                            </option>
                          ))}
                      </Select>
                      <FormErrorMessage>
                        {errors?.operadora?.message}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      isInvalid={entidadeValue && entidadeValue.length < 1}
                      errortext={errors?.entidade?.message}
                      isRequired
                    >
                      <FormLabel htmlFor="entidade">Pessoa Jurídica</FormLabel>
                      <Select
                        placeholder="Selecione uma pessoa jurídica"
                        id="entidade"
                        type="text"
                        {...register("entidade")}
                        onChange={(e) => setEntidadeValue(e.target.value)}
                      >
                        {entidades &&
                          entidades.map((entidade) => (
                            <option key={entidade.id} value={entidade.id}>
                              {entidade.nm_entidade}
                            </option>
                          ))}
                      </Select>
                      <FormErrorMessage>
                        {errors?.entidade?.message}
                      </FormErrorMessage>
                    </FormControl>
                    {entidades.find(
                      (entidade) =>
                        entidade.id === parseInt(entidadeValue) &&
                        entidade.tipos_entidade.tp_entidade === "Empresa",
                    ) && (
                      <>
                        <FormControl>
                          <FormLabel htmlFor="vinculo">
                            Possui vínculo com outra entidade?
                          </FormLabel>
                          <Select
                            id="vinculo"
                            name="vinculo"
                            type="text"
                            value={vinculo}
                            onChange={(e) => {
                              setVinculo(e.target.value);
                              // if (e.target.value === "1") {
                              //   setInputEntidadeVinculada(null);
                              // }
                            }}
                          >
                            <option key="1" value="1">
                              Não
                            </option>
                            <option key="2" value="2">
                              Sim
                            </option>
                          </Select>
                        </FormControl>
                      </>
                    )}
                    {vinculo &&
                      vinculo === "2" &&
                      entidades.find(
                        (entidade) =>
                          entidade.id === parseInt(entidadeValue) &&
                          entidade.tipos_entidade.tp_entidade === "Empresa",
                      ) && (
                        <>
                          <FormControl
                            isInvalid={!!errors?.entidade_vinculada?.message}
                            errortext={errors?.entidade_vinculada?.message}
                            isRequired={vinculo === "2" ? true : false}
                          >
                            <FormLabel htmlFor="entidade">
                              Entidade vinculada
                            </FormLabel>
                            <Select
                              placeholder="Selecione a entidade vinculada"
                              id="entidade_vinculada"
                              type="text"
                              {...register("entidade_vinculada")}
                            >
                              {entidades &&
                                entidades.map(
                                  (entidade) =>
                                    entidade.tipos_entidade.tp_entidade !==
                                      "Empresa" && (
                                      <option
                                        key={entidade.id}
                                        value={entidade.id}
                                      >
                                        {entidade.nm_entidade}
                                      </option>
                                    ),
                                )}
                            </Select>
                            <FormErrorMessage>
                              {errors?.entidade_vinculada?.message}
                            </FormErrorMessage>
                          </FormControl>
                        </>
                      )}
                    <Box
                      display="flex"
                      gridColumnGap="10px"
                      justifyContent="end"
                      margin="20px 0 0"
                    >
                      <Button
                        onClick={() => {
                          handleNext();
                          setLimiteData(getValues("dt_ini_vigencia"));

                          setPessoaJuridicaType(
                            entidades.find(
                              (op) => op.id === parseInt(getValues("entidade")),
                            )?.tipos_entidade?.tp_entidade,
                          );
                          setTipoMovimentacao(
                            entidades.find(
                              (op) => op.id === parseInt(getValues("entidade")),
                            )?.tipos_entidade?.tp_entidade === "Empresa" &&
                              (respPeloPagamento?.length < 1 ||
                                respPeloPagamento === undefined ||
                                respPeloPagamento === "F")
                              ? null
                              : entidades.find(
                                  (op) =>
                                    op.id === parseInt(getValues("entidade")),
                                )?.tipos_entidade?.tp_entidade === "Empresa" &&
                                (respPeloPagamento === "P" ||
                                  respPeloPagamento === "E")
                              ? "cobrança"
                              : getValues("tipo_movimentacao") || "nenhum",
                          );
                          setPessoaJuridicaName(
                            entidades.find(
                              (op) => op.id === parseInt(getValues("entidade")),
                            )?.nm_entidade,
                          );
                          if (vinculo && vinculo === "2") {
                            setEntidadeVinculadaName(
                              entidades.find(
                                (op) =>
                                  op.id ===
                                  parseInt(getValues("entidade_vinculada")),
                              )?.nm_entidade,
                            );
                          }
                        }}
                        fontWeight="500"
                        colorScheme="blue"
                        disabled={
                          !!errors?.dt_ini_vigencia ||
                          !!errors?.desc_contrato ||
                          !!errors?.tipos_contrato ||
                          !!errors?.operadora ||
                          (entidadeValue && entidadeValue.length < 1)
                        }
                      >
                        Continuar
                      </Button>
                    </Box>
                  </Grid>
                </StepContent>
              </Step>
              <Step key="2">
                <StepLabel>
                  <Text fontSize="16px">Funcionalidades - Pessoa Jurídica</Text>
                </StepLabel>
                <StepContent>
                  {pessoaJuridicaType ? (
                    <>
                      {pessoaJuridicaType !== "Empresa" && (
                        <Grid gap={6}>
                          <FormControl
                            isRequired={pessoaJuridicaType !== "Empresa"}
                          >
                            <FormLabel htmlFor="tipo_movimentacao">
                              Tipo de movimentação
                            </FormLabel>
                            <Select
                              // placeholder="Selecione o tipo de movimentação"
                              id="tipo_movimentacao"
                              type="text"
                              {...register("tipo_movimentacao")}
                              onChange={(e) =>
                                setTipoMovimentacao(e.target.value)
                              }
                              // defaultValue="nenhum"
                            >
                              <option key="1" value="nenhum">
                                Nenhum
                              </option>
                              <option key="2" value="cobrança">
                                Cobrança
                              </option>
                              <option key="3" value="repasse_taxas">
                                Repasse de Taxas
                              </option>
                            </Select>
                            <FormErrorMessage>
                              {errors?.tipo_movimentacao?.message}
                            </FormErrorMessage>
                          </FormControl>
                          <Divider marginBottom="5px" />
                        </Grid>
                      )}

                      {pessoaJuridicaType === "Empresa" ||
                      tipoMovimentacao === "cobrança" ? (
                        <>
                          <Text
                            textAlign="center"
                            fontSize="18px"
                            fontWeight="500"
                            marginTop="15px"
                          >
                            Cobrança de faturas
                          </Text>
                          <Divider marginBottom="15px" />
                          <Grid gap={6}>
                            {pessoaJuridicaType === "Empresa" && (
                              <FormControl>
                                <FormLabel htmlFor="fl_resp_pelo_pagamento">
                                  Responsável pelo pagamento
                                </FormLabel>
                                <Select
                                  // placeholder="Selecione o responsável pelo pagamento"
                                  id="fl_resp_pelo_pagamento"
                                  type="text"
                                  {...register("fl_resp_pelo_pagamento")}
                                  onChange={(e) => {
                                    if (
                                      e.target.value === "P" ||
                                      e.target.value === "E"
                                    ) {
                                      setTipoMovimentacao("cobrança");
                                    } else {
                                      setTipoMovimentacao(null);
                                    }
                                    setRespPeloPagamento(e.target.value);
                                  }}
                                  defaultValue="F"
                                >
                                  <option key="1" value="F">
                                    Pessoa Física
                                  </option>
                                  <option key="2" value="P">
                                    Pessoa Jurídica:{" "}
                                    {pessoaJuridicaName && pessoaJuridicaName}
                                  </option>
                                  {vinculo === "2" && (
                                    <option key="3" value="E">
                                      Entidade Vinculada:{" "}
                                      {entidadeVinculadaName &&
                                        entidadeVinculadaName}
                                    </option>
                                  )}
                                </Select>
                              </FormControl>
                            )}

                            {((respPeloPagamento &&
                              respPeloPagamento !== "F") ||
                              pessoaJuridicaType !== "Empresa") && (
                              <>
                                {limiteData.length > 0 && (
                                  <Text color="blue.600" fontWeight="500">
                                    Data de início da Vigência:{" "}
                                    {moment(limiteData).format("MM/YYYY")}
                                  </Text>
                                )}
                                <FormControl>
                                  <FormLabel htmlFor="ano_ini_vigenc_ext_bol_not">
                                    Ano da primeira competência a ser cobrada
                                  </FormLabel>
                                  <Select
                                    // placeholder="Selecione o ano"
                                    id="ano_ini_vigenc_ext_bol_not"
                                    type="text"
                                    {...register("ano_ini_vigenc_ext_bol_not")}
                                    defaultValue={moment().year()}
                                  >
                                    <option key="1" value={moment().year()}>
                                      {moment().year()}
                                    </option>
                                    <option key="2" value={moment().year() + 1}>
                                      {moment().year() + 1}
                                    </option>
                                  </Select>
                                </FormControl>

                                <FormControl>
                                  <FormLabel htmlFor="mes_ini_vigenc_ext_bol_not">
                                    Mês da primeira competência a ser cobrada
                                  </FormLabel>
                                  <Select
                                    // placeholder="Selecione o mês"
                                    id="mes_ini_vigenc_ext_bol_not"
                                    type="text"
                                    {...register("mes_ini_vigenc_ext_bol_not")}
                                    defaultValue={moment().month() + 1}
                                  >
                                    {meses &&
                                      meses.map((mes, i) => (
                                        <option key={i} value={i + 1}>
                                          {mes}
                                        </option>
                                      ))}
                                  </Select>
                                </FormControl>

                                <FormControl>
                                  <FormLabel htmlFor="dia_venc_extrato_boleto_nota">
                                    Dia de vencimento dos boletos
                                  </FormLabel>
                                  <Select
                                    id="dia_venc_extrato_boleto_nota"
                                    {...register(
                                      "dia_venc_extrato_boleto_nota",
                                    )}
                                  >
                                    {dias.map((dia, i) => (
                                      <option key={i} value={dia}>
                                        {dia}
                                      </option>
                                    ))}
                                  </Select>
                                </FormControl>

                                <FormControl>
                                  <FormLabel htmlFor="dia_limite_ext_bol_not">
                                    Dia limite para validação
                                  </FormLabel>
                                  <Select
                                    id="dia_limite_ext_bol_not"
                                    {...register("dia_limite_ext_bol_not")}
                                  >
                                    {dias.map((dia, i) => (
                                      <option key={i} value={dia}>
                                        {dia}
                                      </option>
                                    ))}
                                  </Select>
                                </FormControl>

                                <FormControl>
                                  <FormLabel htmlFor="fl_libera_valid_extbolnot_mes_anterior">
                                    Validação da fatura
                                  </FormLabel>
                                  <Select
                                    id="fl_libera_valid_extbolnot_mes_anterior"
                                    {...register(
                                      "fl_libera_valid_extbolnot_mes_anterior",
                                    )}
                                    defaultValue="nao"
                                  >
                                    <option key="1" value="nao">
                                      Mês competência
                                    </option>
                                    <option key="2" value="sim">
                                      Mês anterior a competência
                                    </option>
                                  </Select>
                                </FormControl>
                              </>
                            )}
                          </Grid>
                        </>
                      ) : (
                        tipoMovimentacao === "repasse_taxas" && (
                          <>
                            <Text
                              textAlign="center"
                              fontSize="18px"
                              fontWeight="500"
                              marginTop="15px"
                            >
                              Repasse de Taxas
                            </Text>
                            <Divider marginBottom="15px" />
                            <Grid gap={6}>
                              {limiteData.length > 0 && (
                                <Text color="blue.600" fontWeight="500">
                                  Data de início da Vigência:{" "}
                                  {moment(limiteData).format("MM/YYYY")}
                                </Text>
                              )}
                              <FormControl>
                                <FormLabel htmlFor="ano_inicio_repasse">
                                  Ano da primeira competência
                                </FormLabel>
                                <Select
                                  // placeholder="Selecione o ano"
                                  id="ano_inicio_repasse"
                                  type="text"
                                  {...register("ano_inicio_repasse")}
                                  defaultValue={moment().year()}
                                >
                                  <option key="1" value={moment().year()}>
                                    {moment().year()}
                                  </option>
                                  <option key="2" value={moment().year() + 1}>
                                    {moment().year() + 1}
                                  </option>
                                </Select>
                              </FormControl>

                              <FormControl>
                                <FormLabel htmlFor="mes_inicio_repasse">
                                  Mês da primeira competência
                                </FormLabel>
                                <Select
                                  // placeholder="Selecione o mês"
                                  id="mes_inicio_repasse"
                                  type="text"
                                  {...register("mes_inicio_repasse")}
                                  defaultValue={moment().month() + 1}
                                >
                                  {meses &&
                                    meses.map((mes, i) => (
                                      <option key={i} value={i + 1}>
                                        {mes}
                                      </option>
                                    ))}
                                </Select>
                              </FormControl>

                              <FormControl>
                                <FormLabel htmlFor="dia_repasse">
                                  Dia de repasse
                                </FormLabel>
                                <Select
                                  id="dia_repasse"
                                  {...register("dia_repasse")}
                                >
                                  {dias.map((dia, i) => (
                                    <option key={i} value={dia}>
                                      {dia}
                                    </option>
                                  ))}
                                </Select>
                              </FormControl>

                              <FormControl>
                                <FormLabel htmlFor="periodo_vencimento">
                                  Período do repasse
                                </FormLabel>
                                <Select
                                  id="periodo_vencimento"
                                  {...register("periodo_vencimento")}
                                  defaultValue="1"
                                >
                                  <option key="1" value="1">
                                    Mesmo mês
                                  </option>
                                  <option key="2" value="2">
                                    Mês seguinte
                                  </option>
                                  <option key="3" value="3">
                                    Mês subsequente
                                  </option>
                                </Select>
                              </FormControl>
                            </Grid>
                          </>
                        )
                      )}
                    </>
                  ) : (
                    <Alert status="warning">
                      <AlertIcon />
                      Preencha a Pessoa Jurídica
                    </Alert>
                  )}

                  <Box
                    display="flex"
                    gridColumnGap="10px"
                    justifyContent="end"
                    margin="20px 0 0"
                  >
                    <Button
                      onClick={handleBack}
                      color="white"
                      _hover={{
                        backgroundColor: "gray.600",
                      }}
                    >
                      Voltar
                    </Button>

                    {pessoaJuridicaType && (
                      <Button
                        onClick={handleNext}
                        fontWeight="500"
                        colorScheme="blue"
                      >
                        Continuar
                      </Button>
                    )}
                  </Box>
                </StepContent>
              </Step>
              <Step key="3">
                <StepLabel>
                  <Text fontSize="16px">Funcionalidades - Operadora</Text>
                </StepLabel>
                <StepContent>
                  <Grid gap={6}>
                    <Text
                      textAlign="center"
                      fontSize="18px"
                      fontWeight="500"
                      marginTop="15px"
                    >
                      Coparticipação
                    </Text>
                    <Divider marginBottom="15px" />
                    <FormControl
                      isInvalid={!!errors?.fl_copart?.message}
                      errortext={errors?.fl_copart?.message}
                      isRequired
                    >
                      <FormLabel htmlFor="fl_copart">
                        A operadora envia arquivo de coparticipação para
                        validação?
                      </FormLabel>
                      <Select
                        id="fl_copart"
                        {...register("fl_copart")}
                        onChange={(e) => {
                          setFl_copartValue(e.target.value);
                          if (e.target.value === "sim") {
                            setFl_copart(true);
                            setValue("dia_notificacao", "01");
                            setValue("dia_venc_copart", "01");
                            setValue("fl_copart", "sim");
                          } else {
                            setFl_copart(false);
                            setValue("dia_notificacao", "");
                            setValue("dia_venc_copart", "");
                            setValue("fl_copart", "nao");
                          }
                        }}
                      >
                        <option key="1" value="nao">
                          Não
                        </option>
                        <option key="2" value="sim">
                          Sim
                        </option>
                      </Select>
                      <FormErrorMessage>
                        {errors?.fl_copart?.message}
                      </FormErrorMessage>
                    </FormControl>
                    {fl_copartValue === "sim" && (
                      <>
                        <FormControl
                          isInvalid={!!errors?.dia_notificacao?.message}
                          errortext={errors?.dia_notificacao?.message}
                          isRequired={fl_copartValue === "sim" ? true : false}
                        >
                          <FormLabel htmlFor="dia_notificacao">
                            Dia limite para o recebimento do arquivo
                          </FormLabel>
                          <Select
                            id="dia_notificacao"
                            {...register("dia_notificacao")}
                          >
                            {dias.map((dia, i) => (
                              <option key={i} value={dia}>
                                {dia}
                              </option>
                            ))}
                          </Select>
                          <FormErrorMessage>
                            {errors?.dia_notificacao?.message}
                          </FormErrorMessage>
                        </FormControl>

                        <FormControl
                          isInvalid={!!errors?.dia_venc_copart?.message}
                          errortext={errors?.dia_venc_copart?.message}
                          isRequired={fl_copartValue === "sim" ? true : false}
                        >
                          <FormLabel htmlFor="dia_venc_copart">
                            Dia padrão de vencimento
                          </FormLabel>
                          <Select
                            id="dia_venc_copart"
                            {...register("dia_venc_copart")}
                          >
                            {dias.map((dia, i) => (
                              <option key={i} value={dia}>
                                {dia}
                              </option>
                            ))}
                          </Select>
                          <FormErrorMessage>
                            {errors?.dia_venc_copart?.message}
                          </FormErrorMessage>
                        </FormControl>
                      </>
                    )}
                  </Grid>

                  <Divider margin="35px 0 15px" />

                  {tipoMovimentacao === "cobrança" && (
                    <Grid gap={6}>
                      <Text
                        textAlign="center"
                        fontSize="18px"
                        fontWeight="500"
                        marginTop="15px"
                      >
                        Sinistralidade
                      </Text>
                      <Divider marginBottom="15px" />
                      <FormControl
                        isInvalid={!!errors?.fl_sinistralidade?.message}
                        errortext={errors?.fl_sinistralidade?.message}
                        isRequired
                      >
                        <FormLabel htmlFor="fl_sinistralidade">
                          A operadora enviará a sinistralidade mensalmente?
                        </FormLabel>
                        <Select
                          id="fl_sinistralidade"
                          {...register("fl_sinistralidade")}
                          onChange={(e) => {
                            setFl_sinistralidadeValue(e.target.value);
                            if (e.target.value === "sim") {
                              setFl_sinistralidade(true);
                              setValue("dia_recebimento_arq_sinist", "01");
                              setValue("fl_sinistralidade", "sim");
                            } else {
                              setFl_sinistralidade(false);
                              setValue("dia_recebimento_arq_sinist", "");
                              setValue("fl_sinistralidade", "nao");
                            }
                          }}
                        >
                          <option key="1" value="nao">
                            Não
                          </option>
                          <option key="2" value="sim">
                            Sim
                          </option>
                        </Select>
                        <FormErrorMessage>
                          {errors?.fl_sinistralidade?.message}
                        </FormErrorMessage>
                      </FormControl>
                      {fl_sinistralidadeValue === "sim" && (
                        <>
                          <FormControl
                            isInvalid={
                              !!errors?.dia_recebimento_arq_sinist?.message
                            }
                            errortext={
                              errors?.dia_recebimento_arq_sinist?.message
                            }
                            isRequired={
                              fl_sinistralidadeValue === "sim" ? true : false
                            }
                          >
                            <FormLabel htmlFor="dia_recebimento_arq_sinist">
                              Dia para o recebimento dos arquivos
                            </FormLabel>
                            <Select
                              id="dia_recebimento_arq_sinist"
                              {...register("dia_recebimento_arq_sinist")}
                            >
                              {dias.map((dia, i) => (
                                <option key={i} value={dia}>
                                  {dia}
                                </option>
                              ))}
                            </Select>
                            <FormErrorMessage>
                              {errors?.dia_recebimento_arq_sinist?.message}
                            </FormErrorMessage>
                          </FormControl>
                        </>
                      )}
                    </Grid>
                  )}

                  {(!!errors?.dt_ini_vigencia ||
                    !!errors?.desc_contrato ||
                    !!errors?.tipos_contrato ||
                    !!errors?.fl_sinistralidade ||
                    (fl_sinistralidadeValue === "sim" &&
                      !!errors?.dia_recebimento_arq_sinist) ||
                    !!errors?.fl_copart ||
                    (fl_copartValue === "sim" &&
                      (!!errors?.dia_notificacao ||
                        !!errors?.dia_venc_copart)) ||
                    !!errors?.operadora ||
                    !!errors?.entidade) && (
                    <Box
                      textAlign="center"
                      fontSize="17px"
                      color="#E53E3E"
                      fontWeight="500"
                      marginTop="10px"
                    >
                      Preencha os campos obrigatórios indicados com (*)
                    </Box>
                  )}
                  <Box
                    display="flex"
                    gridColumnGap="10px"
                    justifyContent="end"
                    margin="20px 0 0"
                  >
                    <Button
                      onClick={handleBack}
                      color="white"
                      _hover={{
                        backgroundColor: "gray.600",
                      }}
                    >
                      Voltar
                    </Button>
                    <Button
                      isLoading={isSubmitting}
                      type="submit"
                      colorScheme="blue"
                      disabled={
                        !!errors?.dt_ini_vigencia ||
                        !!errors?.desc_contrato ||
                        !!errors?.tipos_contrato ||
                        !!errors?.fl_copart ||
                        (fl_copartValue === "sim" &&
                          (!!errors?.dia_notificacao ||
                            !!errors?.dia_venc_copart)) ||
                        !!errors?.operadora ||
                        !!errors?.entidade ||
                        !!errors?.fl_sinistralidade ||
                        (fl_sinistralidadeValue === "sim" &&
                          !!errors?.dia_recebimento_arq_sinist)
                      }
                    >
                      Salvar
                    </Button>
                  </Box>
                </StepContent>
              </Step>
            </Stepper>
          </form>
        </AddSection>
        <Box as="form" paddingInline="4">
          <MaterialTable
            icons={tableIcons}
            title="Contratos Ativos"
            data={contracts.filter((data: Contract) => {
              return data.fl_ativo;
            })}
            localization={{
              body: {
                emptyDataSourceMessage: "Nenhum dado cadastrado.",
              },
              pagination: {
                labelDisplayedRows: "{from}-{to} de {count}",
                labelRowsSelect: "linhas",
                previousTooltip: "Página anterior",
                nextTooltip: "Próxima página",
                firstTooltip: "Primeira página",
                lastTooltip: "Última página",
              },
              toolbar: {
                searchPlaceholder: "Buscar",
                exportTitle: "Exportar",
                exportAriaLabel: "Exportar",
                exportPDFName: "Exportar como PDF",
              },
            }}
            options={{
              emptyRowsWhenPaging: false,
              tableLayout: "auto",
              exportButton: {
                pdf: true,
                csv: false,
              },
            }}
            columns={[
              {
                title: "Nome",
                field: "desc_contrato",
                cellStyle: {
                  width: "18,4%",
                },
              },
              {
                title: "Data vigência",
                field: "dt_ini_vigencia",
                render: (element) => {
                  if (!element.dt_ini_vigencia) {
                    return <Text>Nenhuma data estabelecida</Text>;
                  } else {
                    return (
                      <Text>{FormataStringData(element.dt_ini_vigencia)}</Text>
                    );
                  }
                },
                cellStyle: {
                  width: "18,4%",
                },
              },
              {
                title: "Tipo de contrato",
                field: "tipos_contrato.tp_contrato",
                render: (element) => {
                  if (!element.tipos_contrato) {
                    return <Text>Nenhum tipo especificado</Text>;
                  } else {
                    return <Text>{element.tipos_contrato.tp_contrato}</Text>;
                  }
                },
                cellStyle: {
                  width: "18,4%",
                },
              },
              {
                title: "Operadora",
                field: "operadora.nm_operadora",
                render: (element) => {
                  if (!element.operadora.nm_operadora) {
                    return <Text>Nenhuma</Text>;
                  } else {
                    return <Text>{element.operadora.nm_operadora}</Text>;
                  }
                },
                cellStyle: {
                  width: "18,4%",
                },
              },
              {
                title: "Pessoa Jurídica",
                field: "entidade.nm_entidade",
                render: (element) => {
                  if (!element.entidade) {
                    return <Text>Nenhuma</Text>;
                  } else {
                    return <Text>{element.entidade.nm_entidade}</Text>;
                  }
                },
                cellStyle: {
                  width: "18,4%",
                },
              },
              {
                title: "Responsável pelo Pagamento",
                field:
                  "entidade_vinculada.nm_entidade" || "entidade.nm_entidade",
                render: (element) => {
                  if (!element.entidade) {
                    return <Text>Nenhuma</Text>;
                  } else {
                    if (element.fl_resp_pelo_pagamento === "P") {
                      return <Text>{element.entidade.nm_entidade}</Text>;
                    } else if (element.fl_resp_pelo_pagamento === "E") {
                      return (
                        <Text>{element.entidade_vinculada.nm_entidade}</Text>
                      );
                    } else {
                      return <Text paddingLeft="25px">-</Text>;
                    }
                  }
                },
                cellStyle: {
                  width: "18,4%",
                },
              },
              {
                title: "Editar",
                cellStyle: {
                  width: "4%",
                },
                render: (element) => {
                  return (
                    <>
                      <IconButton
                        aria-label="Editar"
                        icon={<Icon as={MdModeEdit} />}
                        fontSize="24"
                        variant="unstyled"
                        onClick={() => {
                          onOpen();
                          setCurrentClosing(null);
                          setCoparticipacao(null);
                          setSinistralidade(null);
                          setCurrentEditing(element.id);
                          setInputDtIniVigencia(element.dt_ini_vigencia);
                          setInputDescContrato(element.desc_contrato);
                          setInputTipos_Contrato(element.tipos_contrato?.id);
                          setInputOperadora(element.operadora?.id);
                          setInputEntidade(element.entidade?.id);
                          setInputEntidadeVinculada(
                            element.entidade_vinculada?.id,
                          );
                          setInputFl_copart(element.fl_copart);
                          setInputFl_sinistralidade(element.fl_sinistralidade);
                          setInputDia_notificacao(
                            addZeroes(element.dia_notificacao),
                          );
                          setInputDia_venc_copart(
                            addZeroes(element.dia_venc_copart),
                          );
                          setInputDia_sinistralidade(
                            addZeroes(element.dia_recebimento_arq_sinist),
                          );
                        }}
                      />
                    </>
                  );
                },
              },
              {
                title: "Encerrar Contrato",
                cellStyle: {
                  width: "4%",
                },
                render: (element) => {
                  return (
                    <>
                      <IconButton
                        aria-label="Encerrar Contrato"
                        icon={<Icon as={MdFolderOpen} />}
                        fontSize="24"
                        variant="unstyled"
                        onClick={() => {
                          onOpen();
                          setDateClosingError(false);
                          reset2();
                          setCurrentEditing(null);
                          setCurrentClosing(element.id);
                          setCurrentIniVigencia(element);
                        }}
                      />
                    </>
                  );
                },
              },
            ]}
          />
        </Box>
        <Box as="form" paddingInline="4" marginTop="30px">
          <MaterialTable
            icons={tableIcons}
            title="Contratos Encerrados"
            data={contracts.filter((data: Contract) => {
              return !data.fl_ativo;
            })}
            localization={{
              body: {
                emptyDataSourceMessage: "Nenhum dado cadastrado.",
              },
              pagination: {
                labelDisplayedRows: "{from}-{to} de {count}",
                labelRowsSelect: "linhas",
                previousTooltip: "Página anterior",
                nextTooltip: "Próxima página",
                firstTooltip: "Primeira página",
                lastTooltip: "Última página",
              },
              toolbar: {
                searchPlaceholder: "Procurar",
              },
            }}
            options={{ emptyRowsWhenPaging: false, tableLayout: "auto" }}
            columns={[
              {
                title: "Nome",
                field: "desc_contrato",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Data encerramento",
                field: "dt_fim_vigencia",
                render: (element) => {
                  if (!element.dt_fim_vigencia) {
                    return <Text>Nenhuma data estabelecida</Text>;
                  } else {
                    return (
                      <Text>{FormataStringData(element.dt_fim_vigencia)}</Text>
                    );
                  }
                },
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Tipo de contrato",
                field: "tipos_contrato.tp_contrato",
                render: (element) => {
                  if (!element.tipos_contrato) {
                    return <Text>Nenhum tipo especificado</Text>;
                  } else {
                    return <Text>{element.tipos_contrato.tp_contrato}</Text>;
                  }
                },
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Operadora",
                field: "operadora.nm_operadora",
                render: (element) => {
                  if (!element.operadora.nm_operadora) {
                    return <Text>Nenhuma</Text>;
                  } else {
                    return <Text>{element.operadora.nm_operadora}</Text>;
                  }
                },
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Pessoa Jurídica",
                field: "entidade.nm_entidade",
                render: (element) => {
                  if (!element.entidade) {
                    return <Text>Nenhuma</Text>;
                  } else {
                    return <Text>{element.entidade.nm_entidade}</Text>;
                  }
                },
                cellStyle: {
                  width: "20%",
                },
                sorting: false,
              },
            ]}
          />
        </Box>
      </Box>
      {currentClosing && (
        <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
          <ModalOverlay backgroundColor="blackAlpha.500" />
          <ModalContent
            paddingBottom="4"
            marginLeft="15px"
            marginRight="15px"
            marginTop="80px"
          >
            <ModalHeader>Encerrar Contrato</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <form
                onSubmit={handleSubmit2(onSubmit2)}
                onReset={(event) => {
                  event.preventDefault();
                  reset2(defaultValues2);
                }}
              >
                <Grid gap={6}>
                  <FormControl
                    isInvalid={!!errors?.dt_fim_vigencia?.message}
                    errortext={errors?.dt_fim_vigencia?.message}
                    isRequired
                  >
                    <Box display="flex" gridColumnGap="5px">
                      Contrato:{" "}
                      <Text fontWeight="500">
                        {currentIniVigencia.desc_contrato}
                      </Text>
                    </Box>
                    <Box display="flex" gridColumnGap="5px">
                      Data do início da vigência:{" "}
                      <Text fontWeight="500">
                        {moment(currentIniVigencia.dt_ini_vigencia).format(
                          "DD/MM/YYYY",
                        )}
                      </Text>
                    </Box>
                    <Divider margin="20px 0" />

                    <FormLabel htmlFor="dt_fim_vigencia">
                      Data do fim da Vigência
                    </FormLabel>
                    <Input
                      id="dt_fim_vigencia"
                      type="date"
                      {...register2("dt_fim_vigencia")}
                      onChange={(e: any) => {
                        if (
                          moment(e.target.value).format() <
                          moment(currentIniVigencia.dt_ini_vigencia).format()
                        ) {
                          setDateClosingError(true);
                        } else {
                          setDateClosingError(false);
                        }
                      }}
                    />
                    {dateClosingError && (
                      <Text
                        color="#E53E3E"
                        fontSize="15px"
                        fontWeight="500"
                        paddingTop="10px"
                      >
                        * A data do fim da vigência não pode ser menor que a
                        data do início.
                      </Text>
                    )}
                    <FormErrorMessage>
                      {errors?.dt_fim_vigencia?.message}
                    </FormErrorMessage>
                  </FormControl>
                  <Button
                    isLoading={isSubmitting2}
                    type="submit"
                    colorScheme="blue"
                    disabled={!!errors2.dt_fim_vigencia || dateClosingError}
                  >
                    Salvar
                  </Button>
                </Grid>
              </form>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
      {currentEditing && (
        <Modal
          isOpen={isOpen}
          onClose={() => {
            onClose();
            setActiveStep(0);
          }}
          scrollBehavior="inside"
        >
          <ModalOverlay backgroundColor="blackAlpha.500" />
          <ModalContent
            paddingBottom="4"
            marginLeft="15px"
            marginRight="15px"
            marginTop="80px"
          >
            <ModalHeader>Editar Contrato</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Stepper activeStep={activeStep} orientation="vertical">
                <Step key="1">
                  <StepLabel>
                    <Text fontSize="16px">Dados do contrato</Text>
                  </StepLabel>
                  <StepContent>
                    <Grid gap={6}>
                      <FormControl
                        isInvalid={
                          inputDtIniVigencia?.length < 1 ? true : false
                        }
                        isRequired
                      >
                        <FormLabel htmlFor="dt_ini_vigencia">
                          Data de início da Vigência
                        </FormLabel>
                        <Input
                          id="dt_ini_vigencia"
                          name="dt_ini_vigencia"
                          type="date"
                          onChange={(e) => {
                            setInputDtIniVigencia(e.target.value);
                          }}
                          defaultValue={inputDtIniVigencia}
                        />
                        <FormErrorMessage>
                          Esse campo não pode ficar vazio
                        </FormErrorMessage>
                      </FormControl>

                      <FormControl
                        isInvalid={inputDescContrato?.length < 1 ? true : false}
                        isRequired
                      >
                        <FormLabel htmlFor="desc_contrato">
                          Nome do contrato
                        </FormLabel>
                        <Input
                          id="desc_contrato"
                          name="desc_contrato"
                          type="text"
                          onChange={(e) => {
                            setInputDescContrato(e.target.value);
                          }}
                          defaultValue={inputDescContrato}
                        />
                        <FormErrorMessage>
                          Esse campo não pode ficar vazio
                        </FormErrorMessage>
                      </FormControl>

                      <FormControl
                        isInvalid={
                          inputTipos_Contrato?.length < 1 ? true : false
                        }
                        isRequired
                      >
                        <FormLabel htmlFor="tipos_contrato">
                          Tipo do contrato
                        </FormLabel>
                        <Select
                          // placeholder="Selecione o tipo"
                          id="tipos_contrato"
                          name="tipos_contrato"
                          type="text"
                          onChange={(e) => {
                            setInputTipos_Contrato(e.target.value);
                          }}
                          defaultValue={inputTipos_Contrato}
                        >
                          {tipoContratos &&
                            tipoContratos.map((tipo) => {
                              return (
                                <option key={tipo.id} value={tipo.id}>
                                  {tipo.tp_contrato}
                                </option>
                              );
                            })}
                        </Select>
                        <FormErrorMessage>
                          Esse campo não pode ficar vazio
                        </FormErrorMessage>
                      </FormControl>

                      <FormControl
                        isInvalid={inputOperadora?.length < 1 ? true : false}
                        isRequired
                      >
                        <FormLabel htmlFor="operadora">Operadora</FormLabel>
                        <Select
                          // placeholder="Selecione uma operadora"
                          id="operadora"
                          name="operadora"
                          type="text"
                          onChange={(e) => {
                            setInputOperadora(e.target.value);
                          }}
                          defaultValue={inputOperadora}
                        >
                          {operadoras &&
                            operadoras.map((operadora) => {
                              return (
                                <option key={operadora.id} value={operadora.id}>
                                  {operadora.nm_operadora}
                                </option>
                              );
                            })}
                        </Select>
                        <FormErrorMessage>
                          Esse campo não pode ficar vazio
                        </FormErrorMessage>
                      </FormControl>

                      <FormControl
                        isInvalid={inputEntidade?.length < 1 ? true : false}
                        isRequired
                      >
                        <FormLabel htmlFor="entidade">
                          Pessoa Jurídica
                        </FormLabel>
                        <Select
                          // placeholder="Selecione uma pessoa jurídica"
                          id="entidade"
                          name="entidade"
                          type="text"
                          onChange={(e) => {
                            setInputEntidade(e.target.value);
                          }}
                          defaultValue={inputEntidade}
                        >
                          {entidades &&
                            entidades.map((entidade) => {
                              return (
                                <option key={entidade.id} value={entidade.id}>
                                  {entidade.nm_entidade}
                                </option>
                              );
                            })}
                        </Select>
                        <FormErrorMessage>
                          Esse campo não pode ficar vazio
                        </FormErrorMessage>
                      </FormControl>
                      {entidades.find(
                        (entidade) =>
                          entidade.id === parseInt(inputEntidade) &&
                          entidade.tipos_entidade.tp_entidade === "Empresa",
                      ) && (
                        <>
                          <FormControl>
                            <FormLabel htmlFor="vinculo">
                              Possui vínculo com outra entidade?
                            </FormLabel>
                            <Select
                              id="vinculo"
                              name="vinculo"
                              type="text"
                              onChange={(e) => {
                                setVinculo(e.target.value);
                                if (e.target.value === "1") {
                                  setInputEntidadeVinculada(null);
                                }
                              }}
                              value={
                                vinculo
                                  ? vinculo
                                  : inputEntidadeVinculada && "2"
                              }
                            >
                              <option key="1" value="1">
                                Não
                              </option>
                              <option key="2" value="2">
                                Sim
                              </option>
                            </Select>
                          </FormControl>
                        </>
                      )}
                      {(vinculo === "2" || inputEntidadeVinculada) &&
                        entidades.find(
                          (entidade) =>
                            entidade.id === parseInt(inputEntidade) &&
                            entidade.tipos_entidade.tp_entidade === "Empresa",
                        ) && (
                          <>
                            <FormControl
                              isInvalid={
                                vinculo === "2" &&
                                inputEntidadeVinculada?.length < 1
                                  ? true
                                  : false
                              }
                              isRequired={vinculo === "2"}
                            >
                              <FormLabel htmlFor="entidade">
                                Entidade vinculada
                              </FormLabel>
                              <Select
                                // placeholder="Selecione a entidade vinculada"
                                id="entidade_vinculada"
                                name="entidade_vinculada"
                                type="text"
                                onChange={(e) => {
                                  setInputEntidadeVinculada(e.target.value);
                                }}
                                defaultValue={inputEntidadeVinculada}
                              >
                                {entidades &&
                                  entidades.map(
                                    (entidade) =>
                                      entidade.tipos_entidade.tp_entidade !==
                                        "Empresa" && (
                                        <option
                                          key={entidade.id}
                                          value={entidade.id}
                                        >
                                          {entidade.nm_entidade}
                                        </option>
                                      ),
                                  )}
                              </Select>
                              <FormErrorMessage>
                                Esse campo não pode ficar vazio
                              </FormErrorMessage>
                            </FormControl>
                          </>
                        )}

                      <Box
                        display="flex"
                        justifyContent="flex-end"
                        gridColumnGap="10px"
                      >
                        <Button
                          width="130px"
                          onClick={handleNext}
                          colorScheme="blue"
                          disabled={
                            (vinculo === "2" &&
                              inputEntidadeVinculada?.length < 1) ||
                            inputEntidade?.length < 1 ||
                            inputOperadora?.length < 1 ||
                            inputTipos_Contrato?.length < 1 ||
                            inputDescContrato?.length < 1 ||
                            inputDtIniVigencia?.length < 1
                          }
                        >
                          Continuar
                        </Button>
                      </Box>
                    </Grid>
                  </StepContent>
                </Step>
                <Step key="2">
                  <StepLabel>
                    <Text fontSize="16px">Funcionalidades - Operadora</Text>
                  </StepLabel>
                  <StepContent>
                    {/* <Grid gap={6}>
                      <Text
                        textAlign="center"
                        fontSize="18px"
                        fontWeight="500"
                        marginTop="15px"
                      >
                        Coparticipação
                      </Text>
                      <Divider marginBottom="15px" />
                      <FormControl>
                        <FormLabel htmlFor="fl_copart_edit">
                          Os planos possuem coparticipação?
                        </FormLabel>
                        <Select
                          id="fl_copart_edit"
                          name="fl_copart_edit"
                          onChange={(e) => {
                            setCoparticipacao(e.target.value);
                            if (e.target.value === "sim") {
                              setInputFl_copart(true);
                              setInputDia_notificacao("01");
                              setInputDia_venc_copart("01");
                            } else {
                              setInputFl_copart(false);
                              setInputDia_notificacao(null);
                              setInputDia_venc_copart(null);
                            }
                          }}
                          value={
                            coparticipacao === "nao"
                              ? coparticipacao
                              : inputFl_copart && "sim"
                          }
                        >
                          <option key="1" value="nao">
                            Não
                          </option>
                          <option key="2" value="sim">
                            Sim
                          </option>
                        </Select>
                      </FormControl>

                      {(coparticipacao === "sim" || inputFl_copart) && (
                        <>
                          <FormControl
                            isInvalid={
                              coparticipacao === "sim" &&
                              inputDia_notificacao?.length < 1
                                ? true
                                : false
                            }
                            isRequired={coparticipacao === "sim"}
                          >
                            <FormLabel htmlFor="dia_notificacao_edit">
                              Dia limite para o recebimento do arquivo
                            </FormLabel>
                            <Select
                              id="dia_notificacao_edit"
                              name="dia_notificacao_edit"
                              onChange={(e) => {
                                setInputDia_notificacao(e.target.value);
                              }}
                              defaultValue={inputDia_notificacao}
                            >
                              {dias.map((dia, i) => {
                                return (
                                  <option key={i} value={dia}>
                                    {dia}
                                  </option>
                                );
                              })}
                            </Select>
                            <FormErrorMessage>
                              Esse campo não pode ficar vazio
                            </FormErrorMessage>
                          </FormControl>

                          <FormControl
                            isInvalid={
                              coparticipacao === "sim" &&
                              inputDia_venc_copart?.length < 1
                                ? true
                                : false
                            }
                            isRequired={coparticipacao === "sim"}
                          >
                            <FormLabel htmlFor="dia_venc_copart_edit">
                              Dia padrão de vencimento
                            </FormLabel>
                            <Select
                              id="dia_venc_copart_edit"
                              name="dia_venc_copart_edit"
                              onChange={(e) => {
                                setInputDia_venc_copart(e.target.value);
                              }}
                              defaultValue={inputDia_venc_copart}
                            >
                              {dias.map((dia, i) => {
                                return (
                                  <option key={i} value={dia}>
                                    {dia}
                                  </option>
                                );
                              })}
                            </Select>
                            <FormErrorMessage>
                              Esse campo não pode ficar vazio
                            </FormErrorMessage>
                          </FormControl>
                        </>
                      )}
                    </Grid>

                    <Grid gap={6}>
                      <Text
                        textAlign="center"
                        fontSize="18px"
                        fontWeight="500"
                        marginTop="15px"
                      >
                        Sinistralidade
                      </Text>
                      <Divider marginBottom="15px" />
                      <FormControl>
                        <FormLabel
                          htmlFor="
fl_sinistralidade"
                        >
                          A operadora enviará a sinistralidade mensalmente?
                        </FormLabel>
                        <Select
                          id="fl_sinistralidade"
                          name="fl_sinistralidade"
                          onChange={(e) => {
                            setSinistralidade(e.target.value);
                            if (e.target.value === "sim") {
                              setInputFl_sinistralidade(true);
                              setInputDia_sinistralidade("01");
                            } else {
                              setInputFl_sinistralidade(false);
                              setInputDia_sinistralidade(null);
                            }
                          }}
                          value={
                            sinistralidade === "nao"
                              ? sinistralidade
                              : inputFl_sinistralidade && "sim"
                          }
                        >
                          <option key="1" value="nao">
                            Não
                          </option>
                          <option key="2" value="sim">
                            Sim
                          </option>
                        </Select>
                      </FormControl>

                      {(sinistralidade === "sim" || inputFl_sinistralidade) && (
                        <>
                          <FormControl
                            isInvalid={
                              sinistralidade === "sim" &&
                              inputDia_sinistralidade?.length < 1
                                ? true
                                : false
                            }
                            isRequired={sinistralidade === "sim"}
                          >
                            <FormLabel htmlFor="dia_sinistralidade">
                              Dia para recebimento dos arquivos
                            </FormLabel>
                            <Select
                              id="dia_sinistralidade"
                              name="dia_sinistralidade"
                              onChange={(e) => {
                                setInputDia_sinistralidade(e.target.value);
                              }}
                              defaultValue={inputDia_sinistralidade}
                            >
                              {dias.map((dia, i) => {
                                return (
                                  <option key={i} value={dia}>
                                    {dia}
                                  </option>
                                );
                              })}
                            </Select>
                            <FormErrorMessage>
                              Esse campo não pode ficar vazio
                            </FormErrorMessage>
                          </FormControl>
                        </>
                      )}
                    </Grid> */}
                    <Alert status="warning">
                      <AlertIcon />
                      Em desenvolvimento...
                    </Alert>
                    <Box
                      display="flex"
                      gridColumnGap="10px"
                      justifyContent="end"
                      margin="20px 0 0"
                    >
                      <Button
                        onClick={handleBack}
                        color="white"
                        _hover={{
                          backgroundColor: "gray.600",
                        }}
                      >
                        Voltar
                      </Button>
                      <Button
                        onClick={handleNext}
                        fontWeight="500"
                        colorScheme="blue"
                        disabled={
                          (coparticipacao === "sim" &&
                            inputDia_notificacao?.length < 1) ||
                          (coparticipacao === "sim" &&
                            inputDia_venc_copart?.length < 1)
                        }
                      >
                        Continuar
                      </Button>
                    </Box>
                  </StepContent>
                </Step>
                <Step key="3">
                  <StepLabel>
                    <Text fontSize="16px">
                      Funcionalidades - Pessoa Jurídica
                    </Text>
                  </StepLabel>
                  <StepContent>
                    <Text
                      textAlign="center"
                      fontSize="18px"
                      fontWeight="500"
                      marginTop="15px"
                    >
                      Cobrança
                    </Text>
                    <Divider marginBottom="15px" />
                    <Alert status="warning">
                      <AlertIcon />
                      Em desenvolvimento...
                    </Alert>
                    <Grid gap={6}>
                      {/* <FormControl
                      isInvalid={
                        !!errors?.fl_resp_pelo_pagamento?.message ||
                        (respPeloPagamento && respPeloPagamento.length < 1)
                      }
                      errortext={errors?.fl_resp_pelo_pagamento?.message}
                      isRequired
                    >
                      <FormLabel htmlFor="fl_resp_pelo_pagamento">
                        Responsável pelo pagamento
                      </FormLabel>
                      <Select
                        // placeholder="Selecione o responsável pelo pagamento"
                        id="fl_resp_pelo_pagamento"
                        type="text"
                        {...register("fl_resp_pelo_pagamento")}
                        onChange={(e) => setRespPeloPagamento(e.target.value)}
                        defaultValue="F"
                      >
                        <option key="1" value="F">
                          Pessoa Física
                        </option>
                        <option key="2" value="P">
                          Pessoa Jurídica
                        </option>
                        {vinculo === "2" && (
                          <option key="3" value="E">
                            Entidade Vinculada
                          </option>
                        )}
                      </Select>
                      <FormErrorMessage>
                        {errors?.fl_resp_pelo_pagamento?.message}
                      </FormErrorMessage>
                    </FormControl>

                    {respPeloPagamento && respPeloPagamento !== "F" && (
                      <>
                        <FormControl
                          isInvalid={
                            !!errors?.ano_ini_vigenc_ext_bol_not?.message
                          }
                          errortext={
                            errors?.ano_ini_vigenc_ext_bol_not?.message
                          }
                          isRequired
                        >
                          <FormLabel htmlFor="ano_ini_vigenc_ext_bol_not">
                            Ano da primeira vigência a ser cobrada
                          </FormLabel>
                          <Select
                            // placeholder="Selecione o ano"
                            id="ano_ini_vigenc_ext_bol_not"
                            type="text"
                            {...register("ano_ini_vigenc_ext_bol_not")}
                            defaultValue={moment().year()}
                          >
                            <option key="1" value={moment().year()}>
                              {moment().year()}
                            </option>
                            <option key="2" value={moment().year() + 1}>
                              {moment().year() + 1}
                            </option>
                          </Select>
                          <FormErrorMessage>
                            {errors?.ano_ini_vigenc_ext_bol_not?.message}
                          </FormErrorMessage>
                        </FormControl>

                        <FormControl
                          isInvalid={
                            !!errors?.mes_ini_vigenc_ext_bol_not?.message
                          }
                          errortext={
                            errors?.mes_ini_vigenc_ext_bol_not?.message
                          }
                          isRequired
                        >
                          <FormLabel htmlFor="mes_ini_vigenc_ext_bol_not">
                            Mês da primeira vigência a ser cobrada
                          </FormLabel>
                          <Select
                            // placeholder="Selecione o mês"
                            id="mes_ini_vigenc_ext_bol_not"
                            type="text"
                            {...register("mes_ini_vigenc_ext_bol_not")}
                            defaultValue={moment().month() + 1}
                          >
                            {meses &&
                              meses.map((mes, i) => (
                                <option key={i} value={i + 1}>
                                  {mes}
                                </option>
                              ))}
                          </Select>
                          <FormErrorMessage>
                            {errors?.mes_ini_vigenc_ext_bol_not?.message}
                          </FormErrorMessage>
                        </FormControl>

                        <FormControl
                          isInvalid={
                            !!errors?.dia_venc_extrato_boleto_nota?.message
                          }
                          errortext={
                            errors?.dia_venc_extrato_boleto_nota?.message
                          }
                          isRequired
                        >
                          <FormLabel htmlFor="dia_venc_extrato_boleto_nota">
                            Dia de vencimento dos boletos
                          </FormLabel>
                          <Select
                            id="dia_venc_extrato_boleto_nota"
                            {...register("dia_venc_extrato_boleto_nota")}
                          >
                            {dias.map((dia, i) => (
                              <option key={i} value={dia}>
                                {dia}
                              </option>
                            ))}
                          </Select>
                          <FormErrorMessage>
                            {errors?.dia_venc_extrato_boleto_nota?.message}
                          </FormErrorMessage>
                        </FormControl>
                      </>
                    )}
                    */}

                      <Box
                        display="flex"
                        gridColumnGap="10px"
                        justifyContent="end"
                        margin="20px 0 0"
                      >
                        <Button
                          onClick={handleBack}
                          color="white"
                          _hover={{
                            backgroundColor: "gray.600",
                          }}
                        >
                          Voltar
                        </Button>

                        <Button
                          isLoading={editLoading}
                          onClick={handleEditContato}
                          colorScheme="blue"
                          // disabled={

                          // }
                        >
                          Salvar
                        </Button>
                        <Button
                          width="130px"
                          colorScheme="facebook"
                          onClick={() => {
                            onClose();
                            setActiveStep(0);
                            setInputDtIniVigencia("");
                            setInputDescContrato("");
                            setInputTipos_Contrato("");
                            setInputOperadora("");
                            setInputEntidade("");
                            setInputEntidadeVinculada("");
                            setCurrentEditing(null);
                            setEditLoading(false);
                          }}
                        >
                          Cancelar
                        </Button>
                      </Box>
                    </Grid>
                  </StepContent>
                </Step>
              </Stepper>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default Contratos;
